function isUndefined(value: any): boolean {
  return value === undefined
}

export default isUndefined
